import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Clock, AlertCircle } from 'lucide-react';

const CancellationPolicyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-[#0a1628] py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <Link to="/" className="text-[#00bcd4] hover:text-[#00acc1] text-sm flex items-center gap-1 mb-4">
            <ArrowLeft className="w-4 h-4" /> Back to Home
          </Link>
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-white" data-testid="cancellation-policy-title">Cancellation Policy</h1>
          <p className="text-white/70 mt-3">We know plans can change — here's our easy guide</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12 md:py-16" data-testid="cancellation-policy-content">
        {/* Refund tiers */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <div className="p-6 rounded-2xl bg-green-50 border border-green-200 text-center">
            <Clock className="w-8 h-8 text-green-600 mx-auto mb-3" />
            <p className="text-3xl font-bold text-green-700 mb-1">100%</p>
            <p className="text-sm text-green-800 font-medium">Full Refund</p>
            <p className="text-sm text-green-600 mt-2">72+ hours before tour</p>
          </div>
          <div className="p-6 rounded-2xl bg-amber-50 border border-amber-200 text-center">
            <Clock className="w-8 h-8 text-amber-600 mx-auto mb-3" />
            <p className="text-3xl font-bold text-amber-700 mb-1">50%</p>
            <p className="text-sm text-amber-800 font-medium">Half Refund</p>
            <p className="text-sm text-amber-600 mt-2">49–71 hours before tour</p>
          </div>
          <div className="p-6 rounded-2xl bg-red-50 border border-red-200 text-center">
            <AlertCircle className="w-8 h-8 text-red-500 mx-auto mb-3" />
            <p className="text-3xl font-bold text-red-600 mb-1">0%</p>
            <p className="text-sm text-red-700 font-medium">No Refund</p>
            <p className="text-sm text-red-500 mt-2">No-show / full charge applies</p>
          </div>
        </div>

        {/* If We Cancel */}
        <section className="p-6 bg-[#faf9f6] rounded-2xl border border-border/30">
          <h2 className="font-serif text-2xl font-bold text-foreground mb-4">If We Cancel</h2>
          <ul className="space-y-3 text-muted-foreground list-disc pl-6">
            <li>Tours may be canceled due to weather or low participant numbers</li>
            <li>You'll receive a <strong className="text-foreground">full refund</strong> or the chance to reschedule</li>
            <li>Extra travel costs (flights, accommodation) are your responsibility</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default CancellationPolicyPage;
